.unsetPosition {
    position: unset;
}

.videoContainer {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: flex-start;
    position: relative;

    width: 500px;
    height: 500px;
}

.player {
    width: auto;
    height: auto;
    aspect-ratio: var(--videoWidth) / var(--videoHeight);
    max-width: 100%;
    max-height: 100%;
    align-items: center;
}

.canvasOverlay {
    position: absolute;
    display: block;
    top: 0;
    width: 100%;
    height: 100%;
    pointer-events: none;
    object-fit: contain;
    object-position: center top;


    --ratio: calc(var(--videoWidth) / var(--videoHeight));
    --ratio2: calc(var(--codecWidth) / var(--codecHeight));
    width: calc((var(--ratio2) / var(--ratio)) * 100%);
    height: 100%;
    left: calc((1 - var(--ratio2) / var(--ratio)) * 50%);
}

.videoItself {
    width: 100%;
    height: 100%;
    display: block;
    aspect-ratio: var(--videoWidth) / var(--videoHeight);
    object-fit: contain;
    object-position: center top;
}